import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ComparisonValue } from '../models/geo-data';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class ComparisonValueService extends CrudService<ComparisonValue> {
  protected basePath = 'comparison-value'; // Specific for TagService
  public instanceType = 'comparison-value'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
